__webpack_require__.p = "https://app.noteician.com/";